import React from 'react';
import { Box, Card, CardContent, Typography, Stack } from '@mui/material';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';

// Database maintenance (truncating tables, clearing logs/caches, resetting
// data) is a destructive infrastructure operation. It is deliberately NOT
// exposed as a one-click action in this admin dashboard so that live business
// data cannot be wiped by accident. There is no clean-database API, so this
// tab intentionally shows guidance instead of fabricated table rows.
const CleanDatabase = () => (
  <Box sx={{ maxWidth: 640 }}>
    <Card variant="outlined" sx={{ borderColor: 'divider', bgcolor: 'background.paper' }}>
      <CardContent>
        <Stack direction="row" spacing={1.5} alignItems="center" mb={1}>
          <ShieldOutlinedIcon color="warning" />
          <Typography variant="h6" color="text.primary" fontWeight="bold">
            Database maintenance is protected
          </Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          Clearing or truncating database tables is a destructive operation that
          could permanently remove orders, products, customers and other live
          records. To keep your data safe, it is not available as a one-click
          action here.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          If you need to reset or clean up data, please perform it through a
          verified, backed-up server-side maintenance process managed by your
          administrator.
        </Typography>
      </CardContent>
    </Card>
  </Box>
);

export default CleanDatabase;
